// Copyright © SRGTech (Software Resonance Group Inc.). All rights reserved.
// SPDX-License-Identifier: LicenseRef-SRGTech-Proprietary
// See LICENSE and docs/legal/PROPRIETARY_COPYRIGHT.md.

/**
 * Browser entry point for the education control-plane application.
 *
 * The composition root binds the production API clients to the component tree.
 * It performs no network work itself and reads no configuration from the
 * bundle: the BFF is same-origin at `/api/v1`, so one built artefact is
 * promoted unchanged across environments (`DEP-007`, `DOP-002`).
 */

import { createApiClients } from '@eai/ui-shared';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

/** Same-origin BFF base path, versioned per ADR-0002. */
const BFF_BASE_PATH = '/api/v1';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('The application root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App clients={createApiClients({ basePath: BFF_BASE_PATH })} />
  </StrictMode>,
);
